/* eslint-disable no-unused-vars */
/** @module Auth0PreLoginHandlerChangePassword */
/* eslint-disable import/extensions */
import Auth0PreLoginHandlerBase from '../auth0-pre-login-handler-base.mst.mjs';
import Auth0Constants from '../../../../utils/auth0-constants.mjs';
import { Auth0ChangePasswordPageHelper } from '../../../pages/auth0-change-password-page-helper.mst.mjs';

class Auth0PreLoginHandlerChangePassword extends Auth0PreLoginHandlerBase {
  _shouldHandleSync = () => {
    return this._flow === 'changePassword' || this._flow === 'change_password';
  };

  /**
   * @inheritdoc
   */
  async shouldHandle() {
    return Promise.resolve(this._shouldHandleSync());
  }

  /**
   * @inheritdoc
   */
  async run(viewOptions = {}) {
    // the idea is to get a ticket number and then use it to change password.
    // If we already have a ticket, we can proceed with the change password flow mode (vs invoke).
    const hasTicket = !!this._qs.get('ticket');
    new Auth0ChangePasswordPageHelper({
      name: 'Auth0ChangePasswordPageHelper-Invoke',
      tenantOrDomain: this._tenant.id,
      mode: hasTicket ? Auth0Constants.CHANGE_PASSWORD_DISPLAY_MODE_CHANGE : Auth0Constants.CHANGE_PASSWORD_DISPLAY_MODE_INVOKE,
      clientId: this._clientId,
      autoInvoke: !!this._qs.get('auto_invoke'),
      usernameOrEmailPrefill: this._qs.get('username') || this._qs.get('username_or_email'),
      appLoginUrl: this._appLoginUrl,
      whiteLabelOptions: this._whiteLabelOptions,
      isVoluntary: !!this._qs.get('voluntary'),
      ...viewOptions,
    }).render();
    // mark this request as handled
    return true;
  }
}

export default Auth0PreLoginHandlerChangePassword;
